import { useEffect, useState } from "react";
import { getDeadlines } from "../api/deadlines";

const REFRESH_MS = 5 * 60 * 1000;

// Counts open deadlines that need attention, for the sidebar badge. Refreshes on navigation
// (so completing or extending a deadline is reflected straight away) and every few minutes.
export default function useDeadlineAlerts(token, pathname) {
  const [counts, setCounts] = useState({ overdue: 0, dueSoon: 0 });

  useEffect(() => {
    if (!token) return undefined;
    let cancelled = false;

    const load = () =>
      getDeadlines(token)
        .then(({ data }) => {
          if (cancelled) return;
          const rows = data.data || [];
          setCounts({
            overdue: rows.filter((d) => d.status === "OVERDUE").length,
            dueSoon: rows.filter((d) => d.status === "DUE_SOON").length,
          });
        })
        .catch(() => {}); // a badge is not worth an error toast

    load();
    const timer = setInterval(load, REFRESH_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [token, pathname]);

  return counts;
}
